import React from 'react';
import Modal from 'react-modal';
import {ThreeDots} from "react-loader-spinner";

// Loader https://mhnpd.github.io/react-loader-spinner/docs/intro
// Modal https://www.npmjs.com/package/react-modal
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        backgroundColor: 'transparent'
    },
};

const Spinner = () => {
    return (
        <Modal
            isOpen={true}
            style={customStyles}
            ariaHideApp={false}
            contentLabel="Example Modal"
        >
            <p>Sending...</p>
            <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#264653"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
            />
        </Modal>
    );
};

export default Spinner;
